<script setup lang="ts">
import ElementalFormFooter from '../ElementalFormFooter/index.vue'
import FormAutomaticSave from '../FormAutomaticSave/index.vue'
import FormHeader from '../FormHeader/index.vue'
import FloatSection from '../FloatSection/index.vue'

import type {
  ElementalFormEmits,
  ElementalFormProps,
} from '@/composables/elemental-form'

import {
  useElementalForm,
} from '@/composables/elemental-form'

const props = defineProps<ElementalFormProps>()

const emit = defineEmits<ElementalFormEmits>()

const AdvancedForm = defineAsyncComponent(() => import('../AdvancedForm/index.vue'))
const DiscussionForm = defineAsyncComponent(() => import('../DiscussionForm/index.vue'))
const RatingForm = defineAsyncComponent(() => import('../RatingForm/index.vue'))
const SellForm = defineAsyncComponent(() => import('../SellForm/index.vue'))

defineOptions({
  name: 'ElementalFormContextProvider',
})

const {
  form,
  onSubmit,
  cancel,
  reloadElementalFormData,
  formId,
  hasElementalSection,
} = useElementalForm(props, emit)

const formRef = ref<HTMLElement | null>(null)

const elemental = toRef(props, 'elemental')

onMounted(() => {
  if (elemental.value)
    reloadElementalFormData()
})

watch(elemental, (newVal, oldVal) => {
  if (newVal?.id && newVal?.id !== oldVal?.id)
    reloadElementalFormData()
})

onUnmounted(() => form.resetForm())

onErrorCaptured((error) => {
  console.error('ElementalFormContextProvider', error)
  return true
})
</script>

<template>
  <form :id="formId" ref="formRef" @submit.prevent="onSubmit">
    <component
      :is="autosave ? FormAutomaticSave : 'div'"
      :auto-save-id="elemental?.id"
      class="flex flex-col h-full"
      @submit="onSubmit"
    >
      <FormHeader />
      <slot />
      <SellForm v-if="!onlySlots && hasElementalSection" />
      <DiscussionForm v-if="!onlySlots && !noDiscussion" />
      <RatingForm v-if="!onlySlots && !noReview" />
      <AdvancedForm v-if="!onlySlots && !noAdvanced" />
      <slot name="sections" />
      <ElementalFormFooter @cancel="cancel" />
      <FloatSection v-if="!isSidebarView" :is-loading="!!isLoading" />
    </component>
  </form>
</template>
